import React, { useEffect, useMemo, useState } from "react";
import { listStaff } from "./happyschoolApi";
import { getActiveSchoolId } from "./activeSchool";

// Bỏ dấu + hạ chữ thường để tìm "nguyen" ra "Nguyễn".
const norm = (s) => String(s || "").normalize("NFD").replace(/[̀-ͯ]/g, "").replace(/đ/gi, "d").toLowerCase().replace(/\s+/g, " ").trim();
const digits = (s) => String(s || "").replace(/\D/g, "");

const HappySchoolDirectory = () => {
  const schoolId = getActiveSchoolId();
  const [staff, setStaff] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [q, setQ] = useState("");

  useEffect(() => {
    if (!schoolId) return;
    setLoading(true);
    setError("");
    listStaff(schoolId)
      .then((list) => setStaff(Array.isArray(list) ? list : []))
      .catch((e) => setError(e.message))
      .finally(() => setLoading(false));
  }, [schoolId]);

  const rows = useMemo(() => {
    const sorted = [...staff].sort((a, b) => String(a.name || "").localeCompare(String(b.name || ""), "vi"));
    const qn = norm(q);
    const qd = digits(q);
    if (!qn) return sorted;
    return sorted.filter((s) => norm(s.name).includes(qn) || (qd && digits(s.phone).includes(qd)));
  }, [staff, q]);

  if (!schoolId) return <p style={{ color: "#6b7280" }}>Chưa chọn trường.</p>;

  return (
    <div style={{ maxWidth: 720 }}>
      <h3 style={{ margin: "0 0 12px" }}>📇 Nhân viên toàn trường</h3>
      <input
        type="search"
        value={q}
        onChange={(e) => setQ(e.target.value)}
        placeholder="Tìm theo Họ tên hoặc SĐT..."
        style={{ width: "100%", boxSizing: "border-box", padding: "8px 10px", border: "1px solid #d1d5db", borderRadius: 8, fontSize: 14, marginBottom: 8 }}
      />
      {loading ? (
        <p>Đang tải...</p>
      ) : error ? (
        <p style={{ color: "#dc2626" }}>{error}</p>
      ) : (
        <>
          <p style={{ color: "#6b7280", fontSize: 13, margin: "0 0 8px" }}>
            {q.trim() ? `${rows.length}/${staff.length} người` : `${staff.length} người`}
          </p>
          <div style={{ overflowX: "auto", border: "1px solid #e5e7eb", borderRadius: 8 }}>
            <table style={{ borderCollapse: "collapse", fontSize: 14, width: "100%" }}>
              <thead>
                <tr>
                  <th style={{ ...th, width: 50 }}>STT</th>
                  <th style={{ ...th, textAlign: "left" }}>Họ tên</th>
                  <th style={{ ...th, textAlign: "left" }}>SĐT</th>
                </tr>
              </thead>
              <tbody>
                {rows.length === 0 ? (
                  <tr><td style={{ ...td, color: "#6b7280" }} colSpan={3}>Không tìm thấy ai.</td></tr>
                ) : rows.map((s, i) => (
                  <tr key={s.id}>
                    <td style={{ ...td, textAlign: "center" }}>{i + 1}</td>
                    <td style={{ ...td, fontWeight: 600 }}>{s.name}</td>
                    <td style={td}>{s.phone ? <a href={`tel:${digits(s.phone)}`} style={{ color: "#0f766e", textDecoration: "none" }}>{s.phone}</a> : "—"}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}
    </div>
  );
};

const th = { border: "1px solid #e5e7eb", padding: "6px 10px", background: "#f9fafb", whiteSpace: "nowrap" };
const td = { border: "1px solid #e5e7eb", padding: "6px 10px" };

export default HappySchoolDirectory;
